import React, {useEffect, useState} from "react";
import { Main, Content } from '../../../components/Layout'
import { Col, Row } from 'react-bootstrap';
import styleButton from '../../../components/Button/Button.module.css';
import { toast } from 'react-toastify';
import Loading from "../../../components/Loading";
import api from '../../../services/api';
import IcEditar from '../../../components/Svg/IcEditar';
import useWrapper from "../../../hooks/useWrapper";

export default function AdminCompetitors() {
  const { setbreadcrumb, config } = useWrapper();

  const [reload, setreload] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [concurrents, setconcurrents] = useState([]);
  
  useEffect(() => {
    api.get("concurrent", config)
    .then(response => {
      let _concurrents = response.data;
      _concurrents.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      setconcurrents(_concurrents);
    })
    .then(() => {
      setLoadingPage(false);
    })
  }, [reload]);

  const createConcurrent = e => {
    if(!e.name) {
      setreload(!reload);
    }
    else if(!e.id) {
      api.post("concurrent", {
        name: e.name,
        active: 1
      }, config)
      .then(() => {
        toast.success(`Concorrente "${e.name}" adicionado com sucesso!`);
        setreload(!reload);
      })
    }
    else {
      api.put(`concurrent/${e.id}`, {
        name: e.name,
        active: 1
      }, config)
      .then(() => {
        toast.success(`Concorrente "${e.name}" editado com sucesso!`);
        setreload(!reload);
      })
    }
  }

  useEffect(() => {
    setbreadcrumb([
      { label: "Administrativo" },
    ])
  }, []);
  
  return (
    <Main>
      {!loadingPage ? (
        <Content>
          <h2 className="mini-title">Concorrentes</h2>
          <p className="small-label font-italic mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque, reiciendis dolore voluptatibus dolor quam tempora quaerat placeat cumque quasi labore, doloremque officiis repudiandae fugiat non nobis sed voluptatem.</p>
          <Row className="mb-3">
            {concurrents.map((e, i) => (
              <Col sm={4} className="mt-3">
                <div className={styleButton.input_button_list} data-edit={e.editable}>
                  <label>
                    <input
                      type="text"
                      placeholder={`Novo Evento`}
                      value={e.name}
                      disabled={!e.editable}
                      autoFocus
                      onChange={ev => {
                        let _concurrents = [...concurrents];
                        _concurrents[i].name = ev.target.value;
                        setconcurrents(_concurrents);
                      }}
                      onBlur={() => {
                        let _concurrents = [...concurrents];
                        createConcurrent({
                          id: e.id,
                          name: e.name
                        })
                        setTimeout(function() {
                          _concurrents[i].editable = false;
                          setconcurrents(_concurrents);
                        }, 100);
                      }}
                      onKeyPress={ev => {
                        if(ev.charCode === 13) {
                          ev.target.blur();
                        }
                      }}
                    />
                      <button
                        type="button"
                        className="simple-ico"
                        onClick={() => {
                          let _concurrents = [...concurrents];
                          _concurrents[i].editable = true;
                          setconcurrents(_concurrents);
                        }}
                      >
                        {!e.editable && (
                          <IcEditar />
                        )}
                      </button>
                  </label>
                </div>
              </Col>
            ))}
          </Row>
          <button
            className={`${styleButton.button_add}`}
            type="button"
            colorScheme="primary"
            onClick={() => {
              setconcurrents([
                ...concurrents,
                {
                  id: null,
                  editable: true,
                  name: ""
                }
              ])
            }}
          >
            <span>Adicionar Concorrente</span>
          </button>
        </Content>
      ):(
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}